import { BadgeAlert, CircleHelp, Drama, User } from 'lucide-react';
import { UserProfileDetailsInfosItem } from './userProfileDetails';
import { IAdditionalCheck, IHasClassName } from '@/interfaces';
import { useRequestGetEmployees } from '@/hooks/httpRequest';
import { VerificationStateEnum } from '@/enums';
import { getTitleEnumValue } from '@/functions';
import { Badge } from '@/components/ui';
import { cn } from '@/lib/utils.ts';

type TProps = IHasClassName & {
	additionalCheck?: IAdditionalCheck;
}

const BannerAdditionalCheckInfo = ({ additionalCheck, className }: TProps) => {

	const { employees } = useRequestGetEmployees({}, !!additionalCheck);

	const employeeReviewer = employees.find(l => l._id === additionalCheck?.reviewer);

	if (!additionalCheck) {
		return <></>;
	}

	return (
		<div className={cn(
			'px-3 flex flex-col py-3',
			'bg-linear-to-r from-purple-50 to-transparent',
			'flex-col items-center justify-center space-y-2',
			'md:items-start md:justify-start',
			className
		)}>
			<div className={cn(
				'flex flex-col items-center justify-center space-y-2',
				'md:flex-row md:items-start md:justify-start md:space-x-2 md:space-y-0'
			)}>
				<Badge
					variant='outline'
					className='bg-purple-600 text-white space-x-2'>
					{additionalCheck.state === VerificationStateEnum.CERTIFICATION_ERROR && <BadgeAlert size={16} />}
					{additionalCheck.state === VerificationStateEnum.WHITE_PERSON && <User size={16} />}
					{additionalCheck.state === VerificationStateEnum.OTHERS && <CircleHelp size={16} />}
					{additionalCheck.state === VerificationStateEnum.SCAM && <Drama size={16} />}
					<span>
						{getTitleEnumValue('VerificationStateEnum', additionalCheck.state)}
					</span>
				</Badge>
				{
					additionalCheck.comment &&
					<div className='text-sm text-muted-foreground'>
						{additionalCheck.comment}
					</div>
				}
			</div>
			{
				employeeReviewer?.username &&
				<UserProfileDetailsInfosItem>
					<User size={16} />
					<span>
						Signalement effectué par:
					</span>
					<span className='text-purple-600'>
						{employeeReviewer.username}
					</span>
				</UserProfileDetailsInfosItem>
			}
		</div>
	);

};

export default BannerAdditionalCheckInfo;
